import { render, staticRenderFns } from "./healthFactorsResume.vue?vue&type=template&id=75941064"
import script from "./healthFactorsResume.vue?vue&type=script&lang=js"
export * from "./healthFactorsResume.vue?vue&type=script&lang=js"
import style0 from "./healthFactorsResume.vue?vue&type=style&index=0&id=75941064&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports